import { ChildrenProp } from '@/common/types_and_interfaces.ts'
import { cn } from '@/common/utilities.ts'

type WizardStepContentProp = {
  className?: string
} & ChildrenProp
export const WizardStepContent = ({
  children,
  className,
}: WizardStepContentProp) => {
  return <div className={cn('pt-20 w-full px-4', className)}>{children}</div>
}
